<template>
  <div>
    <img
      :src="shareIconUrl"
      :alt="shareIconAlt"
      class="social-share-button"
      aria-hidden="true"
      @click="openShareModal"
      @keydown.enter="openShareModal"
      @keydown.space.prevent="openShareModal"
      tabindex="0"
    />
    <div v-if="isModalVisible" class="social-share-modal-mask">
      <div class="social-share-modal-wrapper">
        <div class="social-share-modal-container">
          <div class="social-share-carousel-mode-header">
            <button
              class="social-share-modal-close"
              @click="closeShareModal"
              aria-label="Close share modal"
            >
              X
            </button>
            <div class="modal-content">
              <h1 class="modal-heading">{{ sharePopupText }}</h1>
              <div class="modal-list">
                <section>
                  <div class="copy-url-wrapper">
                    <input
                      aria-label="spcial-share-url"
                      type="text"
                      :value="currentUrl"
                      class="copy-text-input"
                      readonly
                    />
                    <button
                      @click="copyToClipboard"
                      class="social-share-copy-url-btn"
                    >
                      {{ copyButtonText }}
                    </button>
                  </div>
                  <ul class="social-share-list">
                    <li v-for="link in dynamicSocialLinks" :key="link.name">
                      <a
                        v-hrefsafe="link.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        @click="onChannelClick(link)"
                      >
                        <img
                          :src="link.icon"
                          :alt="link.name"
                          class="icon icon--social"
                        />
                        <span>{{ link.name }}</span>
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const COPY_TEXT_DEFAULT = 'Copy URL';
const COPY_TEXT_SUCCESS = 'Copied!';
export default {
  name: 'ProductShare',
  props: {
    shareIconUrl: {
      type: String,
      required: false,
      default: '',
    },
    shareIconAlt: {
      type: String,
      required: false,
      default: '',
    },
    sharePopupText: {
      type: String,
      required: false,
      default: '',
    },
    shareButtonClickTagging: {
      type: String,
      required: false,
    },
    shareChannelClickTagging: {
      type: String,
      required: false,
    },
    shareableSocialChannels: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      isModalVisible: false,
      currentUrl: '',
      copyButtonText: COPY_TEXT_DEFAULT,
    };
  },
  computed: {
    dynamicSocialLinks() {
      if (
        !this.shareableSocialChannels ||
        this.shareableSocialChannels.length === 0
      ) {
        return [];
      }

      return this.shareableSocialChannels.map((channel) => {
        let baseUrl = channel.MediaLink;

        const encodedPageUrl = encodeURIComponent(this.currentUrl);

        const finalShareUrl = baseUrl + encodedPageUrl;

        return {
          name: channel.MediaName,
          url: finalShareUrl,
          icon: channel.MediaIcon.Src,
        };
      });
    },
  },
  mounted() {
    if (typeof window !== 'undefined') {
      this.currentUrl = window.location.href;
    }
  },
  methods: {
    openShareModal() {
      if (window.dataLayer && this.shareButtonClickTagging) {
        const eventButtonClickData = JSON.parse(this.shareButtonClickTagging);
        window.dataLayer.push(eventButtonClickData.eventProperties);
      }
      this.isModalVisible = true;
    },
    closeShareModal() {
      this.isModalVisible = false;
    },
    onChannelClick(channel) {
      if (window.dataLayer && this.shareChannelClickTagging) {
        const eventData = JSON.parse(this.shareChannelClickTagging);
        if (eventData.eventProperties) {
          eventData.eventProperties.social_network =
            eventData.eventProperties.social_network.replace(
              '[socialChannel]',
              channel.name
            );
        }

        window.dataLayer.push(eventData.eventProperties);
      }
    },
    copyToClipboard() {
      navigator.clipboard
        .writeText(this.currentUrl)
        .then(() => {
          this.copyButtonText = COPY_TEXT_SUCCESS;
          setTimeout(() => {
            this.copyButtonText = COPY_TEXT_DEFAULT;
          }, 2000);
        })
        .catch((err) => {
          console.error('Failed to copy URL: ', err);
        });
    },
  },
};
</script>

<style lang="scss" scoped src="./share.scss"></style>
